import { useQuery } from '@tanstack/react-query';
import type { AssetComponentsDto } from '@siliconx/shared';
import type { ApiError } from '../components/asset-detail/asset-detail-types';
import { api, throwIfNotOk } from './api';
import { qk } from './queryKeys';

export function useAssetComponents(assetId: string, enabled = true) {
  return useQuery<AssetComponentsDto, ApiError>({
    queryKey: qk.assets.components(assetId),
    queryFn: async () => {
      const res = await api.api.client.assets[':assetId'].components.$get({ param: { assetId } });
      await throwIfNotOk(res);
      return (await res.json()) as unknown as AssetComponentsDto;
    },
    enabled,
  });
}
